// 公用state
export default {
  enum: {
    // 订单
    order: {
      typeDesc: [],
      orderStatusDesc: [],
      exchangeCalWay: [],
      contractVersionDesc: [],
      purchaseTypeDesc: [],
      purchaseWayDesc: [],
      yesOrNoFlag: [],
      priceSourceType: [],
      taxType: [],
    },
    // 协议
    agreement: {
      agreementLadderType: [
        { optionCode: '1', optionName: '累计阶梯', checked: 0 },
        { optionCode: '2', optionName: '单次阶梯', checked: 0 },
      ],
      priceType: [
        { optionCode: '1', optionName: '固定价格', checked: 0 },
        { optionCode: '2', optionName: '浮动价格', checked: 0 },
        { optionCode: '3', optionName: '阶梯价格', checked: 0 },
      ],
      type: [
        { optionCode: '0', optionName: '其他', checked: 0 },
        { optionCode: '1', optionName: '合同', checked: 0 },
        { optionCode: '8', optionName: '企业信用报告', checked: 0 },
      ],
      agreementState: [
        { optionCode: '0', optionName: '草稿', checked: 0 },
        { optionCode: '10', optionName: '审批中', checked: 0 },
        { optionCode: '20', optionName: '已审批', checked: 0 },
        { optionCode: '30', optionName: '已退回', checked: 0 },
        { optionCode: '40', optionName: '变更中', checked: 0 },
        { optionCode: '-100', optionName: '已终止', checked: 0 },
      ],
    },
    //合同
    contract: {
      type: [
        { optionCode: '1', optionName: '固定价格', checked: 0 },
        { optionCode: '2', optionName: '浮动价格', checked: 0 },
        { optionCode: '3', optionName: '阶梯价格', checked: 0 },
      ],
    },
    //需求单
    demand: {
      pdAssignmentStatus: [
        { optionCode: '1', optionName: '已关闭', checked: 0 },
        { optionCode: '0', optionName: '未关闭', checked: 0 },
      ],
      pdProjectDemand: [
        { optionCode: '0', optionName: '否', checked: 0 },
        { optionCode: '1', optionName: '是', checked: 0 },
      ],
      pdDemandStatus: [
        { optionCode: '-100', optionName: '作废', checked: 0 },
        { optionCode: '0', optionName: '草稿', checked: 0 },
        { optionCode: '10', optionName: '审批中', checked: 0 },
        { optionCode: '50', optionName: '已审批', checked: 0 },
        { optionCode: '100', optionName: '已退回', checked: 0 },
      ],
      pdType: [
        { optionCode: '1', optionName: '调拨退回', checked: 0 },
        { optionCode: '2', optionName: '采购退回', checked: 0 },
      ],
      pdPushStatus: [
        { optionCode: '1', optionName: '未下推', checked: 0 },
        { optionCode: '2', optionName: '部分下推', checked: 0 },
        { optionCode: '3', optionName: '全部下推', checked: 0 },
        { optionCode: '4', optionName: '已关闭', checked: 0 },
      ],
      pdBillType: [
        { optionCode: '1', optionName: '物资采购', checked: 0 },
        { optionCode: '2', optionName: '服务采购', checked: 0 },
        { optionCode: '3', optionName: '设备采购', checked: 0 },
        { optionCode: '4', optionName: '材料采购', checked: 0 },
        { optionCode: '5', optionName: '备件采购', checked: 0 },
        { optionCode: '6', optionName: '工程服务需求申请', checked: 0 },
      ],
      pdAssignmentType: [
        { optionCode: '1', optionName: '采购', checked: 0 },
        { optionCode: '2', optionName: '调拨', checked: 0 },
      ],
      pdOperationType: [
        { optionCode: '1', optionName: '退回', checked: 0 },
        { optionCode: '2', optionName: '完成采购', checked: 0 },
      ],
      pdDemandType: [
        { optionCode: '1', optionName: '行政物资类', checked: 0 },
        { optionCode: '2', optionName: 'IT硬件类', checked: 0 },
        { optionCode: '3', optionName: '品宣类', checked: 0 },
        { optionCode: '4', optionName: '基建类', checked: 0 },
        { optionCode: '100', optionName: '其他类', checked: 0 },
      ],
      pdPushType: [
        { optionCode: '1', optionName: '下推类型', checked: 0 },
        { optionCode: '2', optionName: '下推调拨', checked: 0 },
        { optionCode: '3', optionName: '下推采购&调拨', checked: 0 },
      ],
    },
    // 发货通知单
    asn: {
      asnStatusDesc: [
        { optionCode: '-100', optionName: '已作废', checked: 0 },
        { optionCode: '-50', optionName: '已撤回', checked: 0 },
        { optionCode: '0', optionName: '草稿', checked: 0 },
        { optionCode: '20', optionName: '已发货', checked: 0 },
        { optionCode: '50', optionName: '已关闭', checked: 0 },
      ],
      asnTypeDesc: [
        { optionCode: '0', optionName: '物资发货通知单', checked: 0 },
      ],
      carrierTypeDesc: [
        { optionCode: '0', optionName: '供应商运输', checked: 0 },
        { optionCode: '1', optionName: '我司自提', checked: 0 },
        { optionCode: '2', optionName: '无需运输', checked: 0 },
      ],
    },
  },
}
